import { useAppSelector } from "common/hooks/storeHooks";
import { accessUid } from "common/selectors/auth.selectors";
import { Nullable } from "common/types";
import React from "react";
import { Link, useLocation } from "react-router";

interface CustomLinkProps {
  children: React.ReactNode;
  href: string;
  target?: "_blank";
  relative?: "route" | "path";
  className?: string;
  onClick?: (args: any) => any;
  appendToCurrent?: boolean;
  rel?: string;
  title?: string;
  "aria-label"?: string;
  "data-test"?: string;
}

export const addAuthUser = (route: string, accessUid: Nullable<string>) => {
  if (!accessUid || accessUid === undefined || accessUid === "") {
    return route;
  }
  let currentParams = "";
  // if we have existing query params, get them out
  // so we can append to them safely
  if (route.includes("?")) {
    [route, currentParams] = route.split("?");
  }
  const routeParams = new URLSearchParams(currentParams);
  routeParams.set("authUser", accessUid);
  return `${route}?${routeParams.toString()}`;
};

export const CustomLink: React.FC<CustomLinkProps> = ({
  children,
  target,
  href,
  relative,
  onClick,
  className,
  appendToCurrent,
  rel,
  title,
  "aria-label": ariaLabel,
  "data-test": dataTest,
}) => {
  const currentAccessUid = useAppSelector(accessUid);
  const location = useLocation();

  const getFinalHref = () => {
    if (appendToCurrent) {
      return `${location.pathname}/${href}`;
    }
    return href;
  };

  // Why: target="_blank" without rel="noopener" leaves callers exposed to
  // reverse-tabnabbing. Default rel when target="_blank" and no rel was passed.
  const effectiveRel = rel ?? (target === "_blank" ? "noopener noreferrer" : undefined);

  return (
    <Link
      to={addAuthUser(getFinalHref(), currentAccessUid)}
      className={className}
      target={target}
      onClick={onClick}
      relative={relative}
      rel={effectiveRel}
      title={title}
      aria-label={ariaLabel}
      data-test={dataTest}>
      {children}
    </Link>
  );
};
